import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { ChevronDown, FileSearch, Database, BarChart, CircleDollarSign } from 'lucide-react';

const PainSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="pain-points" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
            {t('businessAppsPage.pain.title')}
          </h2>
          
          <div className="mb-12">
            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
              {t('businessAppsPage.pain.intro')}
            </p>
            
            {/* Herausforderungen für KMU */}
            <div className="bg-white rounded-xl shadow-md p-6 md:p-8 border border-gray-200 mb-10">
              <h3 className="text-xl font-semibold mb-6 text-blue-800">
                Die 4 Digitalen Baustellen im Mittelstand
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-blue-50 p-5 rounded-lg flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-4 flex-shrink-0">
                    <FileSearch className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">Mangelnde Transparenz</h4>
                    <p className="text-gray-700">
                      Wichtige Geschäftsdaten liegen in verschiedenen Systemen und können nicht einheitlich ausgewertet werden.
                    </p>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-5 rounded-lg flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-4 flex-shrink-0">
                    <BarChart className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">Fehlende Echtzeitübersicht</h4>
                    <p className="text-gray-700">
                      Wichtige Unternehmenszahlen und KPIs sind nicht auf einen Blick verfügbar, sondern müssen manuell ermittelt werden.
                    </p>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-5 rounded-lg flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-4 flex-shrink-0">
                    <Database className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">Ineffiziente Dateneingabe</h4>
                    <p className="text-gray-700">
                      Redundante Daten müssen mehrfach in verschiedene Systeme eingegeben werden, was zu Fehlern und Zeitverlust führt.
                    </p>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-5 rounded-lg flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-4 flex-shrink-0">
                    <CircleDollarSign className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">Kostenintensive Prozesse</h4>
                    <p className="text-gray-700">
                      Manuelle Prozesse binden wertvolle Ressourcen, die durch intelligente Dashboards und Automatisierung freigesetzt werden könnten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Scroll-Hinweis */}
          <div className="text-center">
            <a 
              href="#service" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors"
            >
              {t('businessAppsPage.pain.scrollCTA')}
              <ChevronDown className="ml-2 h-5 w-5 animate-bounce" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainSection; 